import * as React from "react";
const FormFieldSuccessFilled = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 9c0 4.9706 4.0294 9 9 9s9-4.0294 9-9-4.0294-9-9-9-9 4.0294-9 9Zm11.9395-3a.75.75 0 0 1 1.0606 1.0607l-5 5-3-3A.75.75 0 0 1 6.0608 8L8 9.9393 11.9395 6Z" }));
FormFieldSuccessFilled.displayName = "FormFieldSuccessFilled";
var FormFieldSuccessFilled_default = FormFieldSuccessFilled;
export {
  FormFieldSuccessFilled_default as default
};
